import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from 'processes/auth/model/state';
import { FunctionComponent } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ColorPalette } from 'shared/consts/colorPalette';
import { Paper } from 'shared/ui/Paper';
import { createPassword } from 'entities/Auth/api';
import { PasswordForm } from 'shared/ui/PasswordForm';
import { CreatePasswordValues } from 'shared/ui/PasswordForm/consts/validation';
import { Footer } from 'widgets/auth/createPassword/_MainModal/ui/Footer';

export const CPMainModal: FunctionComponent = () => {
	const { token } = useParams();
	const { reset } = useAuthStore();
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleSubmit = (values: CreatePasswordValues): void => {
		createPassword({ token, password: values.password })
			.then((res) => {
				if (res?.data.success) {
					reset();
					localStorage.clear();
					sessionStorage.clear();
					navigate('/create-password/success', { state: { access: true } });
					return;
				}
				navigate('/create-password/link-expired', { state: { access: true } });
			})
			.catch(() => {
				navigate('/create-password/link-expired', { state: { access: true } });
			});
	};

	return (
		<Paper title={t('auth.create_password') as string} sx={{ '& *': { userSelect: 'none' } }}>
			<Typography variant={'body1'} color={ColorPalette.baliHai} sx={{ marginBottom: '35px' }}>
				{t('auth.enter_new_password')}
			</Typography>
			<PasswordForm mode={'create'} onSubmit={handleSubmit} />
			<Footer />
		</Paper>
	);
};
